import { render, staticRenderFns } from "./EasyDrugCard.vue?vue&type=template&id=735219fa&scoped=true"
import script from "./EasyDrugCard.vue?vue&type=script&lang=js"
export * from "./EasyDrugCard.vue?vue&type=script&lang=js"
import style0 from "./EasyDrugCard.vue?vue&type=style&index=0&id=735219fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735219fa",
  null
  
)

export default component.exports